var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password-container"},[_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$i18n.t("auth.resetTitle")))]),_c('profile-security-component',{attrs:{"token":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }